import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getDepositTransactions } from '../../../actions/wallet'
import translate from '../../../locales/translate'
import { Pagination } from 'ggx-componentlibrary/components/table/pagination/pagination.component'

const translateWithPrefix = (key, options) =>
  translate(`wallet.view.${key}`, options)

const DepositActionBar = ({
  currentPage,
  totalCount,
  totalPages,
  loading,
  handlePageNavClick,
}) => (
  <Pagination
    paginationText={translateWithPrefix('totalTransactions', {
      count: totalCount,
    })}
    currentPageNumber={currentPage}
    totalPageNumber={totalPages}
    onPageNavClick={handlePageNavClick}
    loading={loading}
  />
)

DepositActionBar.propTypes = {
  currentPage: PropTypes.number,
  totalCount: PropTypes.number,
  totalPages: PropTypes.number,
  loading: PropTypes.bool,
  handlePageNavClick: PropTypes.func,
}

const mapStateToProps = state => ({
  currentPage: state.deposits.currentPage,
  totalCount: state.deposits.totalCount,
  totalPages: state.deposits.totalPages,
  loading: state.deposits.loading,
})

const mapDispatchToProps = dispatch => ({
  handlePageNavClick: newPageNumber => {
    dispatch(getDepositTransactions({ page: newPageNumber }))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DepositActionBar)
